import blogStyles from 'styles/Blog.module.css';
import styles from 'styles/Credit.module.css';
import TitleLine from 'assets/images/rulebook/title_line.png';
import Lemon from 'assets/images/credit/4siw9nfx1.jpg';
import AbsolutelySame from 'assets/images/credit/absolutely_same.jpg';
import Srroy from 'assets/images/credit/slowroy.jpg';
import Nope from 'assets/images/credit/nope124.jpg';
import Akatsuki from 'assets/images/credit/akatsuki.jpg';
import XLogo from 'assets/images/credit/xlogo.svg';
import GitHubLogo from 'assets/images/credit/github_mark.svg';
import { Helmet } from "react-helmet-async";

const Credit = () => {
  return (
    <>
      <div className={styles["first-view"]}>
        <Helmet>
          <title>クレジット | AREA CUP</title>
          <meta property="og:title" content="クレジット | AREA CUP" />
          <meta name="twitter:title" content="クレジット | AREA CUP" />
        </Helmet>
        <h1 className={styles["credit-title"]}>CREDIT</h1>
        <div className={styles["credit"]}>
          <h2 className={styles["credit-text"]}>クレジット</h2>
          <img src={TitleLine} className={styles["credit-image"]} draggable="false" />
          <div className={styles["diamond1"]}></div>
          <div className={styles["diamond2"]}></div>
        </div>
      </div>
      <div className={styles["background"]}>
        <div className={styles["container"]}>
          <div className={blogStyles["markdown"]}>
            <h1>キービジュアル</h1>
            <div className={styles["profile-container"]}>
              <img src={Lemon} alt="アイコン" className={styles["profile-icon"]} />
              <span className={styles["profile-name"]}>れもんどうおいしい</span>
              <div className={styles["profile-links"]}>
                <a
                  href="https://x.com/4SIW9NFX1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={XLogo} alt="X" />
                </a>
              </div>
            </div>
            
            <p>&nbsp;</p>
            <h1>デザイナー</h1>
            <div className={styles["profile-container"]}>
              <img src={AbsolutelySame} alt="アイコン" className={styles["profile-icon"]} />
              <span className={styles["profile-name"]}>サメ、ゼッタイ。</span>
              <div className={styles["profile-links"]}>
                <a
                  href="https://x.com/absolutely_same"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={XLogo} alt="X" />
                </a>
              </div>
            </div>
            
            <p>&nbsp;</p>
            <h1>エンジニア</h1>
            <div className={styles["profile-container"]}>
              <img src={Nope} alt="アイコン" className={styles["profile-icon"]} />
              <span className={styles["profile-name"]}>きう</span>
              <div className={styles["profile-links"]}>
                <a
                  href="https://x.com/kiu124"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={XLogo} alt="X" />
                </a>
                <a
                  href="https://github.com/nope0124"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={GitHubLogo} alt="GitHub" className={styles["github-icon"]} />
                </a>
              </div>
            </div>
            <div className={styles["profile-container"]}>
              <img src={Srroy} alt="アイコン" className={styles["profile-icon"]} />
              <span className={styles["profile-name"]}>srroy</span>
              <div className={styles["profile-links"]}>
                <a
                  href="https://x.com/s1owroy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={XLogo} alt="X" />
                </a>
                <a
                  href="https://github.com/r1chbread"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={GitHubLogo} alt="GitHub" className={styles["github-icon"]} />
                </a>
              </div>
            </div>
            <p>&nbsp;</p>
            <h1>コピーライター</h1>
            <div className={styles["profile-container"]}>
              <img src={Akatsuki} alt="アイコン" className={styles["profile-icon"]} />
              <span className={styles["profile-name"]}>黒砥あかつき</span>
              <div className={styles["profile-links"]}>
                <a
                  href="https://x.com/dawn_rinne"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["circle"]}
                >
                  <img src={XLogo} alt="X" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Credit;
